interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl?: string;
  ogImage?: string;
  ogType?: 'website' | 'article';
  publishedTime?: string;
  modifiedTime?: string;
}

export default function SEOHead({ title, description, keywords, canonicalUrl, ogImage, ogType = 'website', publishedTime, modifiedTime }: SEOHeadProps) {
  const fullTitle = title.includes('51吃瓜') ? title : `${title} - 51今日吃瓜网`;
  const siteUrl = 'https://www.51chigua.com';
  const fullCanonical = canonicalUrl ? `${siteUrl}${canonicalUrl}` : siteUrl;
  const defaultImage = 'https://readdy.ai/api/search-image?query=Entertainment%20gossip%20news%20website%20header%2C%20dramatic%20dark%20background%20with%20warm%20orange%20and%20red%20accents%2C%20modern%20editorial%20design%2C%20breaking%20news%20aesthetic%2C%20cinematic%20lighting%2C%20bold%20typography%20feel%2C%20professional%20news%20media%20style%2C%20dark%20gradient%20with%20subtle%20texture&width=1200&height=630&seq=og-default-01&orientation=landscape';

  const schemaData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '51今日吃瓜网',
        url: siteUrl,
        description: '全网最新吃瓜资源与爆料入口',
      },
      {
        '@type': 'WebSite',
        name: '51今日吃瓜网',
        url: siteUrl,
      },
      {
        '@type': 'WebPage',
        name: fullTitle,
        description: description,
        url: fullCanonical,
      },
    ],
  };

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullCanonical} />
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content="51今日吃瓜网" />
      <meta property="og:image" content={ogImage || defaultImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="zh_CN" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage || defaultImage} />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
    </>
  );
}